import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { MessageService } from './message.service';
import {ApiResponse} from '../models/factory.model';
import {environment} from '../../../environments/environment';
import {Order, OrderCtor, ProductType} from '../models/order.model';
import { Product, ProductCtor } from '../models/product.model';
import { map } from 'rxjs/operators';
import { Client } from '../models/client.model';
import { ConfService } from './conf.service';


export interface myData {
  type: string;
  id: string;
}

@Injectable()
export class OrderService {
  statusFilter:any = undefined;
  orderNumberFilter:any = undefined;
  numberFilter:any = undefined;
  productTypeFilter:any = undefined;
  supplierFilter:any = undefined;
  clientidFilter:any = undefined;
  userFilter:any = undefined;
  budgetFilter:any = undefined;
  article:string='';
  servicepose:any = undefined;
  checkinDate:any= undefined;
  checkoutDate:any = undefined;
  startServiceFilter:any = undefined;
  sousfamille:any=undefined;
  type:any=undefined;
  servicepos:any = undefined;
  posAchat:any = undefined;
  filterstatus:any =  undefined;
  trueController:boolean = false;
  selectedTypeEventId:any = undefined
  UserId:any = undefined;
  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private confService: ConfService,
  ) {}

  private checkInData = environment.crmTest;
  private apiRoot = environment.crmTest;
  private URL_PREFIX = environment.crmTest;
  public crmurl:string  = environment.crmTest + '/orders?&type=PurchaseOrder&group=1';
  public crmurlProd:string  = environment.crmTest + '/listallproducts/v2?'; 
  public crmurlProdCMD:string  = environment.crmTest + '//listproducts/v2?';

  public crmurlProdOld:string  = environment.crmTest + '/listproducts/v2';

  public crmurlDe:string  =  environment.crmTest + '/orders?';
  
  

 
  getAllProduct(){
    let url = this.crmurlProd;
    // url=url;
    
 if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
      url=url+'&type='+this.productTypeFilter
    }
 if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
      url=url+'&supplier='+this.supplierFilter
    }
  if(this.sousfamille!==undefined && this.sousfamille !== null){
     url = url + '&family='+this.sousfamille;
     console.log('after filter',url);
  }
    
    console.log(url)
    return this.http.get(url);
    // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

  }
  getProductByID(ProductID:any){
    let url = this.crmurlProdOld;
    url=url+'&type='+ProductID;
    return this.http.get(url);
  }
   getAllProductOld(){
    let url = this.crmurlProd;
  
  if(this.servicepos !== undefined){
   url = url + '&pos='+this.servicepos
  }  
  if(this.article.trim()!==''){
    url = url + '&name='+this.article
    }
  if(this.type!==undefined && this.type!='' && this.type!=null ){
      url=url+'&type='+this.type
    }
  if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
      url=url+'&supplier='+this.supplierFilter
    }
  if(this.sousfamille!==undefined && this.sousfamille !== null){
     url = url + '&type='+this.sousfamille;
     console.log('after filter',url);
  }
  if(this.sousfamille==undefined && this.supplierFilter==undefined && this.type==undefined && this.article.trim()==''  && this.servicepos == undefined && this.servicepose == undefined){
    url = url + '&type=3735';
     console.log('after filter',url);
  }

  if(this.servicepose !== undefined && this.servicepose !== null){
  url = url + '&pos='+this.servicepose;
  }
    // url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;    
    url = url + '&group=-1';
    console.log(url)
    return this.http.get(url);
    // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

   }
   check(createdfrom:any,cretaedto:any,posId:any){
    let url = environment.crmTest + '/allorders?&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId+'&createdfrom='+createdfrom+'&createdto='+cretaedto+'&type=Delivery&status=4&pos='+posId;
    // let url = 'https://crmapi.valeriahotels.com/api/allorders?&group=1&createdfrom='+createdfrom+'&createdto='+cretaedto+'&type=Delivery&status=4&pos='+posId;
    return this.http.get(url);
   }
   getAllProductOldCMD(){
    let url = this.crmurlProdCMD;

  if(this.article.trim()!==''){
    url = url + '&name='+this.article
    }
  if(this.type!==undefined && this.type!='' && this.type!=null ){
      url=url+'&type='+this.type
    }
  if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
      url=url+'&supplier='+this.supplierFilter
    }
  if(this.sousfamille!==undefined && this.sousfamille !== null){
     url = url + '&family='+this.sousfamille;
     console.log('after filter',url);
  }
  if(this.sousfamille==undefined && this.supplierFilter==undefined && this.type==undefined && this.article.trim()=='' ){
    url = url + '&family=2';
     console.log('after filter',url);
  }  
    console.log(url)
    return this.http.get(url);
    // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

   }
   
  getAllCheckinsA(){
    let url = this.crmurl;
    if (this.checkinDate !== undefined && this.checkoutDate !== undefined ) {
      console.log("this.checkinDate in service checkin", this.checkinDate);
      url = url + '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
    } else if (this.checkinDate === undefined && this.checkoutDate === undefined ) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      url = url + 'createdfrom=' + formattedDate + '&createdto=' + formattedDate;
    } else if (this.checkinDate !== undefined && this.checkoutDate === undefined) {
      url = url + 'createdfrom=' + this.checkinDate + '&createdto=' + this.checkinDate;
    } else if (this.checkoutDate !== undefined && this.checkinDate === undefined) {
      url = url + 'createdfrom=' + this.checkoutDate + '&createdto=' + this.checkoutDate;
    }
  
  if(this.budgetFilter!==undefined && this.budgetFilter!=''  && this.budgetFilter!=null){
    url=url+'&amount='+this.budgetFilter 
  }
      // url = url + '&createdfrom=2023-08-01&createdto=2023-08-08'
      url=url+'&status=0'
 
 if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
      url=url+'&number='+this.numberFilter
    }
 if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
      url=url+'&producttype='+this.productTypeFilter
    }
 if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
      url=url+'&supplier='+this.supplierFilter
    }
 if(this.clientidFilter!==undefined && this.clientidFilter!='' && this.clientidFilter!=null){
      url=url+'&customer='+this.clientidFilter
    }
    
    console.log(url)
    return this.http.get(url);
    // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

   }
  getAllCheckinsB(){
  let url = this.crmurlDe;
  url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
  if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
      console.log("this.checkinDate in service checkin", this.checkinDate);
      url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
  } else if (this.startServiceFilter !== undefined) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
  }
 
 if(this.statusFilter!==undefined && this.statusFilter!='' && this.statusFilter!=null){
  if(this.statusFilter == 'Pending'){
    url=url+'&type=Delivery';  
    url=url+'&status=0'
  }else{
    url=url+'&type=PurchaseOrder'; 
    url=url+'&status=4'
  }
       
  }else{
   url=url+'&type=PurchaseOrder';
   url=url+'&status=4' 
  }    
 if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
      url=url+'&number='+this.numberFilter
    }
 if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
      url=url+'&producttype='+this.productTypeFilter
    }
 if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
      url=url+'&supplier='+this.supplierFilter
    }
//  if(this.clientidFilter!==undefined && this.clientidFilter!='' && this.clientidFilter!=null){
//       url=url+'&customer='+this.clientidFilter
//     }
    
    console.log(url)
    return this.http.get(url);
    // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

   }
   getAllCheckinsBDA(page:number){
    let url = this.crmurlDe;
    url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
        console.log("this.checkinDate in service checkin", this.checkinDate);
        url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
    } else if (this.startServiceFilter !== undefined) {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
    }
   
   if(this.statusFilter!==undefined && this.statusFilter!='' && this.statusFilter!=null){
    if(this.statusFilter == 'Pending'){
      url=url+'&type=Delivery';  
      url=url+'&status=0'
    }else{
      url=url+'&type=PurchaseOrder'; 
      url=url+'&status=4'
    }
         
    }else{
     url=url+'&type=PurchaseOrder';
     url=url+'&status=4' 
    }    
   if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
        url=url+'&number='+this.numberFilter
      }
   if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
        url=url+'&producttype='+this.productTypeFilter
      }
   if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
        url=url+'&supplier='+this.supplierFilter
      }
  //  if(this.clientidFilter!==undefined && this.clientidFilter!='' && this.clientidFilter!=null){
  //       url=url+'&customer='+this.clientidFilter
  //     }
      url = url + '&page='+page+'&size=20';
      console.log(url)
      return this.http.get(url);
      // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
  
     }

    getAllActivity() {
      let groupId = JSON.parse(localStorage.getItem("userDetails"))?.group?.groupId;
      let url = `${environment.crmTest}/audit/allevent?groupid=${groupId}`;
    
      const formatDate = (date: Date, hour: string): string => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}T${hour}`;
      };
    
      if (this.checkinDate && this.checkoutDate) {
        console.log("checkin", this.checkinDate, "checkout", this.checkoutDate);
    
        const checkin = new Date(this.checkinDate);
        const checkout = new Date(this.checkoutDate);
    
        url += `&createdfrom=${formatDate(checkin, '00:00:00')}&createdto=${formatDate(checkout, '23:59:59')}`;
      } else if (this.startServiceFilter) {
        const today = new Date();
        const formatted = formatDate(today, '00:00:00');
        url += `&createdfrom=${formatted}&createdto=${formatDate(today, '23:59:59')}`;
      }

      if (this.selectedTypeEventId) {
        url += `&type=${this.selectedTypeEventId}`;
      }
      
      if (this.UserId) {
        url += `&userid=${this.UserId}`;
      }

      
      console.log("Final URL:", url);
      return this.http.get(url);
    }

    getbackInPeriod() {
      let groupId = JSON.parse(localStorage.getItem("userDetails"))?.group?.groupId;
      let url = `${environment.crmTest}/daily-bac?groupId=${groupId}`;
    
      const formatDate = (date: Date): string => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
      };
    
      if (this.checkinDate && this.checkoutDate) {
        console.log("checkin", this.checkinDate, "checkout", this.checkoutDate);
    
        const checkin = new Date(this.checkinDate);
        const checkout = new Date(this.checkoutDate);
    
        url += `&from=${formatDate(checkin)}&to=${formatDate(checkout)}`;
      } else if (this.startServiceFilter) {
        const today = new Date();
        const formatted = formatDate(today);
        url += `&from=${formatted}&to=${formatDate(today)}`;
      }

      

      
      console.log("Final URL:", url);
      return this.http.get(url);
    }
    // getAllActivityHistory(itemid:any) {
    //   let groupId = JSON.parse(localStorage.getItem("userDetails"))?.group?.groupId;
    //   let url = `${environment.crmTest}/audit/allevent?groupid=${groupId}`;

    //   if (itemid) {
    //     url += `&itemid=${itemid}`;
    //   }

      
    //   console.log("Final URL:", url);
    //   return this.http.get(url);
    // }

    getAllActivityHistory(itemid: any) {
      const groupId = JSON.parse(localStorage.getItem("userDetails"))?.group?.groupId;
      let url = `${environment.crmTest}/audit/allevent?groupid=${groupId}`;

      if (itemid) {
        url += `&itemid=${itemid}`;
      }

      console.log("Final URL:", url);

      return this.http.get<any[]>(url).pipe( // 👈 Assure que c’est bien un tableau
        map(response => response || []) // 👈 Par sécurité si null/undefined
      );
    }
    
   
   getAllCheckinsBService(){
    let url = this.crmurlDe;
    url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
        console.log("this.checkinDate in service checkin", this.checkinDate);
        url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
    } else if (this.startServiceFilter !== undefined) {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
    }
   
    url=url+'&type=PurchaseOrder';
    url=url+'&status=1'    
   if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
        url=url+'&number='+this.numberFilter
      }
   if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
        url=url+'&producttype='+this.productTypeFilter
      }
   if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
        url=url+'&supplier='+this.supplierFilter
      }
  //  if(this.clientidFilter!==undefined && this.clientidFilter!='' && this.clientidFilter!=null){
  //       url=url+'&customer='+this.clientidFilter
  //     }
      
      console.log(url)
      return this.http.get(url);
      // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
  
     }
     getAllCheckinsBServiceB(page:number){
      let url = this.crmurlDe;
      url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
      if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
          console.log("this.checkinDate in service checkin", this.checkinDate);
          url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
      } else if (this.startServiceFilter !== undefined) {
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          const formattedDate = `${year}-${month}-${day}`;
          url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
      }
     
      url=url+'&type=PurchaseOrder';
      url=url+'&status=1'    
     if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
          url=url+'&number='+this.numberFilter
        }
     if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
          url=url+'&producttype='+this.productTypeFilter
        }
     if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
          url=url+'&supplier='+this.supplierFilter
        }
    //  if(this.clientidFilter!==undefined && this.clientidFilter!='' && this.clientidFilter!=null){
    //       url=url+'&customer='+this.clientidFilter
    //     }
        url = url + '&page='+page+'&size=20';
        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    
       }
     getSuiviPurchaseclosed(){
      let url = this.crmurlDe;
      url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
      if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
          console.log("this.checkinDate in service checkin", this.checkinDate);
          url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
      } else if (this.startServiceFilter !== undefined) {
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          const formattedDate = `${year}-${month}-${day}`;
          url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
      }
     
      url=url+'&type=PurchaseOrder'; 
     if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
          url=url+'&number='+this.numberFilter
        }
     if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
          url=url+'&producttype='+this.productTypeFilter
        }
     if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
          url=url+'&supplier='+this.supplierFilter
        }
    //  if(this.clientidFilter!==undefined && this.clientidFilter!='' && this.clientidFilter!=null){
    //       url=url+'&customer='+this.clientidFilter
    //     }
      if(this.filterstatus !== undefined){
        if(this.filterstatus  == 'Preorder'){
         url = url + '&status=1'
        }
        if(this.filterstatus  == 'Pending'){
          url = url + '&status=0'
         }
         if(this.filterstatus  == 'Confirmed'){
          url = url + '&status=4'
         }
      }  
        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    
    }

    closeBackOffice(status: any, createdFrom: any, createdTo: any) {
      const url = `${this.apiRoot}/orders/close?orderType=4&creationDateFrom=${createdFrom}&creationDateTo=${createdTo}&status=${status}`;
      return this.http.get(url);
    }

    ClosingStock(ClosibngStock:any){
      let url =  'https://crmapi.valeriahotels.com/api/stock-closings';
      url = url + '?closedBy='+ClosibngStock.closedBy;
      url = url + '&temporarilyOpened=false';
      url = url + '&groupId='+ClosibngStock.groupId;
      url = url + '&closedAt='+ClosibngStock.closedAt;
      return this.http.post(url,{},{
         headers: { 'Content-Type': 'application/json' }
     });
      
    }

//     ClosingStock(closingData: any): Observable<any> {
//   const url = `https://crmapi.valeriahotels.com/api/stock-closings`;
  
//   const params = new HttpParams()
//     .set('closedBy', closingData.closedBy)
//     .set('temporarilyOpened', closingData.temporarilyOpened.toString())
//     .set('groupId', closingData.groupId.toString())
//     .set('closedAt', closingData.closedAt);

//   return this.http.post(url, {}, { params });
// }

    getStockClosingsByGroup(groupId: number) {
      const url = `https://crmapi.valeriahotels.com/api/stock-closings?groupId=${groupId}`;
      return this.http.get(url);
    }

    
    openBackOffice(status: any, createdFrom: any, createdTo: any) {
      const url = `${this.apiRoot}/orders/reopen?orderType=4&creationDateFrom=${createdFrom}&creationDateTo=${createdTo}&status=${status}`;
      return this.http.get(url);
    }
    
    getSuiviDeliveryclosed(){
      let url = this.crmurlDe;
      url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
      if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
          console.log("this.checkinDate in service checkin", this.checkinDate);
          url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
      } else if (this.startServiceFilter !== undefined) {
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          const formattedDate = `${year}-${month}-${day}`;
          url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
      }
     
      url=url+'&type=Delivery'; 
     if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
          url=url+'&number='+this.numberFilter
        }
     if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
          url=url+'&producttype='+this.productTypeFilter
        }
     if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
          url=url+'&supplier='+this.supplierFilter
        }
    //  if(this.clientidFilter!==undefined && this.clientidFilter!='' && this.clientidFilter!=null){
    //       url=url+'&customer='+this.clientidFilter
    //     }

     if(this.filterstatus !== undefined){
        if(this.filterstatus  == 'Sended'){
        url = url + '&status=0'
        }
        if(this.filterstatus  == 'Factured'){
          url = url + '&status=4'
        }
      }

        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    
    }
    getSuiviPurchase(){
      let url = this.crmurlDe;
      url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
      if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
          console.log("this.checkinDate in service checkin", this.checkinDate);
          url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
      } else if (this.startServiceFilter !== undefined) {
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          const formattedDate = `${year}-${month}-${day}`;
          url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
      }
     
      url=url+'&type=PurchaseOrder'; 
     if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
          url=url+'&number='+this.numberFilter
        }
     if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
          url=url+'&producttype='+this.productTypeFilter
        }
     if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
          url=url+'&supplier='+this.supplierFilter
        }
    //  if(this.clientidFilter!==undefined && this.clientidFilter!='' && this.clientidFilter!=null){
    //       url=url+'&customer='+this.clientidFilter
    //     }
      if(this.filterstatus !== undefined){
        if(this.filterstatus  == 'Preorder'){
         url = url + '&status=1'
        }
        if(this.filterstatus  == 'Pending'){
          url = url + '&status=0'
         }
         if(this.filterstatus  == 'Confirmed'){
          url = url + '&status=4'
         }
      }  
      if(this.posAchat !== undefined){
        url = url +'&pos='+this.posAchat;
      }
        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    
    }
    getSuiviPurchaseD(){
      // let url = this.crmurlDe;
      let url = environment.crmTest + '/allorders?'
      url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
      if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
          console.log("this.checkinDate in service checkin", this.checkinDate);
          url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
      } else if (this.startServiceFilter !== undefined) {
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          const formattedDate = `${year}-${month}-${day}`;
          url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
      }
     
      url=url+'&type=PurchaseOrder'; 
     if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
          url=url+'&number='+this.numberFilter
        }
     if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
          url=url+'&producttype='+this.productTypeFilter
        }
     if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
          url=url+'&supplier='+this.supplierFilter
        }
    //  if(this.clientidFilter!==undefined && this.clientidFilter!='' && this.clientidFilter!=null){
    //       url=url+'&customer='+this.clientidFilter
    //     }
      if(this.filterstatus !== undefined){
        if(this.filterstatus  == 'Preorder'){
         url = url + '&status=1'
        }
        if(this.filterstatus  == 'Pending'){
          url = url + '&status=0'
         }
         if(this.filterstatus  == 'Confirmed'){
          url = url + '&status=4'
         }
      }  
      if(this.posAchat !== undefined){
        url = url +'&pos='+this.posAchat;
      }
        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    
    }
    getSuiviPurchaseExchange(){
      // let url = this.crmurlDe;
      let url = environment.crmTest + '/allorders?'
      url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
      if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
          url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
      } else if (this.startServiceFilter !== undefined) {
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          const formattedDate = `${year}-${month}-${day}`;
          url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
      }
     
      url=url+'&type=Customer'; 
     if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
          url=url+'&number='+this.numberFilter
        }

     
        url=url+'&producttype=5566444'
        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    
    }
    getSuiviDelivery(){
      let url = this.crmurlDe;
      url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
      if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
          console.log("this.checkinDate in service checkin", this.checkinDate);
          url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
      } else if (this.startServiceFilter !== undefined) {
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          const formattedDate = `${year}-${month}-${day}`;
          url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
      }
     
      url=url+'&type=Delivery'; 
     if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
          url=url+'&number='+this.numberFilter
        }
     if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
          url=url+'&producttype='+this.productTypeFilter
        }
     if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
          url=url+'&supplier='+this.supplierFilter
        }
    //  if(this.clientidFilter!==undefined && this.clientidFilter!='' && this.clientidFilter!=null){
    //       url=url+'&customer='+this.clientidFilter
    //     }

     if(this.filterstatus !== undefined){
        if(this.filterstatus  == 'Sended'){
        url = url + '&status=0'
        }
        if(this.filterstatus  == 'Factured'){
          url = url + '&status=4'
        }
      }
      if(this.posAchat !== undefined){
        url = url +'&pos='+this.posAchat;
      }
        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    
    }
    getSuiviDeliveryD(){
      // let url = this.crmurlDe;
      let url = environment.crmTest + '/allorders?'
      url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
      if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
          console.log("this.checkinDate in service checkin", this.checkinDate);
          url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
      } else if (this.startServiceFilter !== undefined) {
          const currentDate = new Date();
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          const formattedDate = `${year}-${month}-${day}`;
          url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
      }
     
      url=url+'&type=Delivery'; 
     if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
          url=url+'&number='+this.numberFilter
        }
     if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
          url=url+'&producttype='+this.productTypeFilter
        }
     if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
          url=url+'&supplier='+this.supplierFilter
        }
    //  if(this.clientidFilter!==undefined && this.clientidFilter!='' && this.clientidFilter!=null){
    //       url=url+'&customer='+this.clientidFilter
    //     }

     if(this.filterstatus !== undefined){
        if(this.filterstatus  == 'Sended'){
        url = url + '&status=0'
        }
        if(this.filterstatus  == 'Factured'){
          url = url + '&status=4'
        }
      }
      if(this.posAchat !== undefined){
        url = url +'&pos='+this.posAchat;
      }
        console.log(url)
        return this.http.get(url);
        // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);
    
    }
   getAllCheckinsInternal() {
    let url = this.crmurlDe;
    url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    console.log("this.checkinDate", this.checkinDate);
    console.log("this.checkoutDate", this.checkoutDate);
  
    if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
      console.log("this.checkinDate in service checkin", this.checkinDate);
      url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
    } else if (this.startServiceFilter !== undefined) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
    }
  
    // Add other filters
    // if (this.budgetFilter !== undefined && this.budgetFilter !== '' && this.budgetFilter !== null) {
    //   url += '&amount=' + this.budgetFilter;
    // }
  
    if (this.statusFilter !== undefined && this.statusFilter !== '' && this.statusFilter !== null) {
      if (this.statusFilter === 'Pending') {
        url += '&type=PurchaseOrder';
        url += '&status=0';
      } else {
        url += '&type=PurchaseOrder';
        url += '&status=4';
      }
    } else {
      url += '&type=PurchaseOrder';
      url += '&status=0';
    }
  
    if (this.numberFilter !== undefined && this.numberFilter !== '' && this.numberFilter !== null) {
      url += '&number=' + this.numberFilter;
    }
  
    if (this.productTypeFilter !== undefined && this.productTypeFilter !== '' && this.productTypeFilter !== null) {
      url += '&producttype=' + this.productTypeFilter;
    }
  
    if (this.supplierFilter !== undefined && this.supplierFilter !== '' && this.supplierFilter !== null) {
      url += '&supplier=' + this.supplierFilter;
    }
  
    if (this.clientidFilter !== undefined && this.clientidFilter !== '' && this.clientidFilter !== null) {
      url += '&customer=' + this.clientidFilter;
    }
  
    console.log("Final URL:", url);
    return this.http.get(url);
  }
  getAllCheckinsInternalA(page:number) {
    let url = this.crmurlDe;
    url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    console.log("this.checkinDate", this.checkinDate);
    console.log("this.checkoutDate", this.checkoutDate);
  
    if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
      console.log("this.checkinDate in service checkin", this.checkinDate);
      url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
    } else if (this.startServiceFilter !== undefined) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
    }
  
    // Add other filters
    // if (this.budgetFilter !== undefined && this.budgetFilter !== '' && this.budgetFilter !== null) {
    //   url += '&amount=' + this.budgetFilter;
    // }
  
    if (this.statusFilter !== undefined && this.statusFilter !== '' && this.statusFilter !== null) {
      if (this.statusFilter === 'Pending') {
        url += '&type=PurchaseOrder';
        url += '&status=0';
      } else {
        url += '&type=PurchaseOrder';
        url += '&status=4';
      }
    } else {
      url += '&type=PurchaseOrder';
      url += '&status=0';
    }
  
    if (this.numberFilter !== undefined && this.numberFilter !== '' && this.numberFilter !== null) {
      url += '&number=' + this.numberFilter;
    }
  
    if (this.productTypeFilter !== undefined && this.productTypeFilter !== '' && this.productTypeFilter !== null) {
      url += '&producttype=' + this.productTypeFilter;
    }
  
    if (this.supplierFilter !== undefined && this.supplierFilter !== '' && this.supplierFilter !== null) {
      url += '&supplier=' + this.supplierFilter;
    }
  
    if (this.clientidFilter !== undefined && this.clientidFilter !== '' && this.clientidFilter !== null) {
      url += '&customer=' + this.clientidFilter;
    }
    url = url +'&page='+page+'&size=20';
    console.log("Final URL:", url);
    return this.http.get(url);
  }
  getMovementInternalall() {
    let url = environment.crmTest + '/allorders?'
    url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    console.log("this.checkinDate", this.checkinDate);
    console.log("this.checkoutDate", this.checkoutDate);
  
    if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
      console.log("this.checkinDate in service checkin", this.checkinDate);
      url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
    } else if (this.startServiceFilter !== undefined) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
    }
    if(this.servicepos !== undefined && this.servicepos !== null){
     url += '&pos='+this.servicepos
    }
    url += '&type=PurchaseOrder';
  
    if (this.numberFilter !== undefined && this.numberFilter !== '' && this.numberFilter !== null) {
      url += '&number=' + this.numberFilter;
    }
  
    if (this.productTypeFilter !== undefined && this.productTypeFilter !== '' && this.productTypeFilter !== null) {
      url += '&producttype=' + this.productTypeFilter;
    }
  
    if (this.supplierFilter !== undefined && this.supplierFilter !== '' && this.supplierFilter !== null) {
      url += '&supplier=' + this.supplierFilter;
    }
  
    if (this.clientidFilter !== undefined && this.clientidFilter !== '' && this.clientidFilter !== null) {
      url += '&customer=' + this.clientidFilter;
    }
  
    console.log("Final URL:", url);
    return this.http.get(url);
  }
  getMovementInternal() {
    let url = this.crmurlDe;
    url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    console.log("this.checkinDate", this.checkinDate);
    console.log("this.checkoutDate", this.checkoutDate);
  
    if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
      console.log("this.checkinDate in service checkin", this.checkinDate);
      url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
    } else if (this.startServiceFilter !== undefined) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
    }
    if(this.servicepos !== undefined && this.servicepos !== null){
     url += '&pos='+this.servicepos
    }
    url += '&type=PurchaseOrder';
    // Add other filters
    // if (this.budgetFilter !== undefined && this.budgetFilter !== '' && this.budgetFilter !== null) {
    //   url += '&amount=' + this.budgetFilter;
    // }
  
    // if (this.statusFilter !== undefined && this.statusFilter !== '' && this.statusFilter !== null) {
    //   if (this.statusFilter === 'Pending') {
    //     url += '&type=PurchaseOrder';
    //     url += '&status=0';
    //   } else {
    //     url += '&type=PurchaseOrder';
    //     url += '&status=4';
    //   }
    // } else {
    //   url += '&type=PurchaseOrder';
    //   url += '&status=0';
    // }
  
    if (this.numberFilter !== undefined && this.numberFilter !== '' && this.numberFilter !== null) {
      url += '&number=' + this.numberFilter;
    }
  
    if (this.productTypeFilter !== undefined && this.productTypeFilter !== '' && this.productTypeFilter !== null) {
      url += '&producttype=' + this.productTypeFilter;
    }
  
    if (this.supplierFilter !== undefined && this.supplierFilter !== '' && this.supplierFilter !== null) {
      url += '&supplier=' + this.supplierFilter;
    }
  
    if (this.clientidFilter !== undefined && this.clientidFilter !== '' && this.clientidFilter !== null) {
      url += '&customer=' + this.clientidFilter;
    }
  
    console.log("Final URL:", url);
    return this.http.get(url);
  }
  getMovementInternalD() {
    let url = environment.crmTest + '/allorders?'
    url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    console.log("this.checkinDate", this.checkinDate);
    console.log("this.checkoutDate", this.checkoutDate);
  
    if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
      console.log("this.checkinDate in service checkin", this.checkinDate);
      url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
    } else if (this.startServiceFilter !== undefined) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
    }
    url += '&type=PurchaseOrder';
    if (this.numberFilter !== undefined && this.numberFilter !== '' && this.numberFilter !== null) {
      url += '&number=' + this.numberFilter;
    }
  
    if (this.productTypeFilter !== undefined && this.productTypeFilter !== '' && this.productTypeFilter !== null) {
      url += '&producttype=' + this.productTypeFilter;
    }
  
    if (this.supplierFilter !== undefined && this.supplierFilter !== '' && this.supplierFilter !== null) {
      url += '&supplier=' + this.supplierFilter;
    }
  
    if (this.clientidFilter !== undefined && this.clientidFilter !== '' && this.clientidFilter !== null) {
      url += '&customer=' + this.clientidFilter;
    }
  
    console.log("Final URL:", url);
    return this.http.get(url);
  }
   getAllCheckinsD(){
    let url = this.crmurlDe;
    url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
      console.log("this.checkinDate in service checkin", this.checkinDate);
      url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
    } else if (this.startServiceFilter !== undefined) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
    }
  if(this.budgetFilter!==undefined && this.budgetFilter!=''  && this.budgetFilter!=null){
    url=url+'&amount='+this.budgetFilter 
  }
 
 
 if(this.statusFilter!==undefined && this.statusFilter!='' && this.statusFilter!=null){
  if(this.statusFilter == 'Pending'){
    url=url+'&type=Delivery';  
    url=url+'&status=0'
  }else{
    url=url+'&type=Delivery'; 
    url=url+'&status=4'
  }
       
  }else{
   url=url+'&type=Delivery';
   url=url+'&status=4' 
  }    
 if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
      url=url+'&number='+this.numberFilter
    }
 if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
      url=url+'&producttype='+this.productTypeFilter
    }
 if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
      url=url+'&supplier='+this.supplierFilter
    }
 if(this.clientidFilter!==undefined && this.clientidFilter!='' && this.clientidFilter!=null){
      url=url+'&customer='+this.clientidFilter
    }
    
    console.log(url)
    return this.http.get(url);
    // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

   }
   getAllCheckinsDPa(page:number){
    let url = this.crmurlDe;
    url = url + '&group='+JSON.parse(localStorage.getItem("userDetails")).group.groupId;
    if (this.checkinDate !== undefined && this.checkoutDate !== undefined) {
      console.log("this.checkinDate in service checkin", this.checkinDate);
      url += '&createdfrom=' + this.checkinDate + '&createdto=' + this.checkoutDate;
    } else if (this.startServiceFilter !== undefined) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      url += '&createdfrom=' + formattedDate + '&createdto=' + formattedDate;
    }
  if(this.budgetFilter!==undefined && this.budgetFilter!=''  && this.budgetFilter!=null){
    url=url+'&amount='+this.budgetFilter 
  }
 
 
 if(this.statusFilter!==undefined && this.statusFilter!='' && this.statusFilter!=null){
  if(this.statusFilter == 'Pending'){
    url=url+'&type=Delivery';  
    url=url+'&status=0'
  }else if(this.statusFilter == 'Confirmed'){
    url=url+'&type=Delivery'; 
    url=url+'&status=4'
  }else{
    url=url+'&type=Delivery'; 
    url=url+'&status=6'
  }
       
  }else{
   url=url+'&type=Delivery';
   url=url+'&status=4' 
  }    
 if(this.numberFilter!==undefined && this.numberFilter!='' && this.numberFilter!=null){
      url=url+'&number='+this.numberFilter
    }
 if(this.productTypeFilter!==undefined && this.productTypeFilter!='' && this.productTypeFilter!=null ){
      url=url+'&producttype='+this.productTypeFilter
    }
 if(this.supplierFilter!==undefined && this.supplierFilter!='' && this.supplierFilter!=null ){
      url=url+'&supplier='+this.supplierFilter
    }
 if(this.clientidFilter!==undefined && this.clientidFilter!='' && this.clientidFilter!=null){
      url=url+'&customer='+this.clientidFilter
    }
    url = url + '&page='+page+'&size=20'
    console.log(url)
    return this.http.get(url);
    // return this.http.get(this.crmUrl + "&startService=" + startService + '&page='+index+'&size='+size);

   }
  
  getAllOrders(page): Observable<ApiResponse<Order>> {
    const url = `${this.checkInData}/orders?page=${page}&type=Customer&producttype=1`;
    return this.http.get<ApiResponse<Order>>(url);
  }

  getOrdersByClient(clientId,type, page): Observable<ApiResponse<Order>> {
    const url = `${this.checkInData}/orders?page=${page}&type=${type}&customer=${clientId}`;
    return this.http.get<ApiResponse<Order>>(url);
  }


  getOrderById(orderId): Observable<ApiResponse<any>> {
    const url = `${this.apiRoot}/order/${orderId}?group=${1}`;
    return this.http.get<ApiResponse<any>>(url);
  }
  getOrderByIdD(orderId): Observable<ApiResponse<any>> {
    const url = `${this.apiRoot}/order/${orderId}`;
    return this.http.get<ApiResponse<any>>(url);
  }
  getArchivesOrderById(orderId) {
    const url = `${this.apiRoot}/order/${orderId}/archives`;
    return this.http.get(url);
  }
  postOrder(order: Order, personId: number) {
    let url = `${this.checkInData}/person/${personId}/order`;

    return this.http.post<ApiResponse<Order>>(url, order, { observe: 'response' });
  }

  getOrderByNumber(orderNbr): Observable<ApiResponse<any>> {
    const url = `${this.checkInData}/order/number/${orderNbr}`;
    return this.http.get<ApiResponse<any>>(url);
  }
  // getFiltredOrders(
  //   type,
  //   number,
  //   createdfrom,
  //   createdto,
  //   budget,
  //   status,
  //   customer,
  //   producttype,
  //   supplier,
  //   page
  // ): Observable<ApiResponse<any>> {
  //   let url = `${this.checkInData}/orders?page=${page}&type=${type}`;
  //   if (number != '') {
  //     url = url + `&number=${number}`;
  //   }
  //   if (createdfrom != '') {
  //     url = url + `&createdfrom=${createdfrom}`;
  //   }
  //   if (createdto != '') {
  //     url = url + `&createdto=${createdto}`;
  //   }
  //   if (budget != '') {
  //     url = url + `&amount=${budget}`;
  //   }
  //   if (status != '') {
  //     url = url + `&status=${status}`;
  //   }
  //   if (customer != '') {
  //     url = url + `&customer=${customer}`;
  //   }
  //   if (producttype != '') {
  //     url = url + `&producttype=${producttype}`;
  //   }
  //   if (supplier != '') {
  //     url = url + `&supplier=${supplier}`;
  //   }
  //   return this.http.get<ApiResponse<any>>(url);
  // }

  /** GET person by id. Will 404 if id not found */
  //   getOrder(id: number): Observable<any> {
  //     const url = `${this.serviceUrl}/${id}`;
  //     return this.http.get<any>(url).pipe(
  //       tap((_) => this.log(`fetched user id=${id}`)),
  //       catchError((err) => this.handleError<any>(`getUser id=${id}`))
  //     );
  //   }

  /** Log a HeroService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`HeroService: ${message}`);
  }
  getOrderByType(type: any, id: any): Observable<Order> {
    if (type === 'Customer' && id === 'new') {
      const orderInstance: OrderCtor = new OrderCtor({
        orderType: 'Customer',
        status: 'Confirmed',
        currency:'MAD',
      });
      return of(orderInstance);
    }
    if (type === 'Supplier' && id === 'new') {
      const orderInstance: OrderCtor = new OrderCtor({
        orderType: 'Supplier',
        status: 'Confirmed',
        currency: environment.devise,
      });
      return of(orderInstance);
    }
    if (type === 'Quote' && id === 'new') {
      const orderInstance: OrderCtor = new OrderCtor({
        orderType: 'Quote',
        status: 'Confirmed',
        currency: environment.devise,
      });
      return of(orderInstance);
    }
    if (type === 'PurchaseOrder' && id === 'new') {
      const orderInstance: OrderCtor = new OrderCtor({
        orderType: 'PurchaseOrder', 
        status: 'Confirmed',
        currency: environment.devise,
      });
      return of(orderInstance);
    }
    let url = `${this.apiRoot}/order/${id}`;
    console.log("here my url",url);
    return this.http.get<Order>(url);

  }
  getProductById(id: any): Observable<Product> {
    console.log('prod service');
    if (id === 'new') {
      const productInstance: ProductCtor = new ProductCtor({
        reference: null,
        producType:null,
        name: null,
        contents: [],
        salesSpitch: [],
        photos: [],
        rateGroups: [],
        ratings: [],
        prices: [],
        customerRating: [],
        supplier: null,
        tags: [],
      });
      return of(productInstance);
    }
    let url = `${this.apiRoot}/product/${id}`;

    return this.http.get<Product>(url);
  }
  getAllproductTypesFamilly(): Observable<ApiResponse<any>> {
    return this.http.get<ApiResponse<any>>(`${this.URL_PREFIX}/allaproducttypes`);
    }
    getAllproductTypesSous(): Observable<ApiResponse<any>> {
      return this.http.get<ApiResponse<any>>(`${this.URL_PREFIX}/allaproducttypes`);
      }
      getAllproductTypes(): Observable<any[]> {
        return this.http.get<any[]>(`${this.URL_PREFIX}/allaproducttypes`);
      }
      
    getCityByCode(term: string): Observable<any> {
      const url = `https://locations.atlasvoyages.com/apollo-giata/api/pois?lang=en&qt=byCode&str=${term}`;
      return this.http.get(url).pipe(
        map((res: ApiResponse<any>) => {
          console.log("getCityByCode in service Order",res);
          return res;
        })
      );
    }
  
    getProspectByName(term: string): Observable<Client[]> {
      const url = `${this.apiRoot}/prospects?criteria=${term}&@ group=-1`;
      return this.http.get<ApiResponse<Client>>(url).pipe(
        map((res: ApiResponse<Client>) => {
          return res.content;
        })
      );
    }

    postFile(fileToUpload: any): Observable<any> {
      const endpoint = 'https://aws.fractalite.com/s3/upload';
      const formData: FormData = new FormData();
      for (let i = 0; i < fileToUpload.length; i++) {
        formData.append('files', fileToUpload[i], fileToUpload[i].name);
      }
  
      return this.http.post(endpoint, formData, { headers: {} }).pipe(
        map((res: any) => {
          return res;
        })
      );
    }




     //https://crmapi.valeriahotels.com/api/products/zero-stock?datefrom=2024-10-01

     private URL_PREFIXX = environment.crmTest+'/products';
  // private URL_PREFIXX = 'https://crmapi.valeriahotels.com/api/products';


  getZeroStockProducts(dateFrom: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.URL_PREFIXX}/zero-stock`, {
      params: {
        datefrom: dateFrom,
      },
    });
  }
  // In your service class

  deleteProductById(productId: number): Observable<any> {
    console.log("Attempting to delete product with ID:", productId);
    return this.http.delete(`${this.URL_PREFIXX}/${productId}`);
  }
  
  getFilteredProducts(dateFrom: string, dateTo: string, articleName: string): Observable<any[]> {
    const params: any = {};
    if (dateFrom) params.datefrom = dateFrom;
    if (dateTo) params.dateto = dateTo;
    if (articleName) params.name = articleName;

    return this.http.get<any[]>(`${this.URL_PREFIXX}/zero-stock`, { params });
  }
  getFiltredOrders(
    type,
    number,
    createdfrom,
    createdto,
    budget,
    status,
    customer,
    producttype,
    supplier,
    startservice,
    endservice,
    startendservice,
    endendservice,
    user,
    otherstatus,
    pos,
    userid,
    country,
    excludeproducttype,
    suppliernumber,
    ordercount,
    page
  ): Observable<ApiResponse<any>> {
    let url = `${this.checkInData}/orders/v2?page=${page}&type=${type}&group=${JSON.parse(localStorage.getItem("userDetails")).group.groupId}`;
    if (suppliernumber != '') {
      url = url + `&suppliernumber=${suppliernumber}`;
    }
    if (number != '') {
      url = url + `&number=${number}`;
    }
    if (createdfrom != '') {
      url = url + `&createdfrom=${createdfrom}`;
    }
    if (createdto != '') {
      url = url + `&createdto=${createdto}`;
    }
    if (budget != '') {
      url = url + `&amount=${budget}`;
    }
    if (status != '') {
      url = url + `&status=${status}`;
    }
    if (customer != '') {
      url = url + `&customer=${customer}`;
    }
    if (producttype != '') {
      url = url + `&producttype=${producttype}`;
    }
    if (supplier != '') {
      url = url + `&supplier=${supplier}`;
    }
    if (startservice != '') {
      url = url + `&startservice=${startservice}`;
    }
    if (endservice != '') {
      url = url + `&endservice=${endservice}`;
    }
    if (startendservice != '') {
      url = url + `&startendservice=${startendservice}`;
    }
    if (endendservice != '') {
      url = url + `&endendservice=${endendservice}`;
    }
    if (user != '') {
      url = url + `&user=${user}`;
    }
    if (otherstatus != '') {
      url = url + `&otherstatus=${otherstatus}`;
    }
    if (pos != '') {
      url = url + `&pos=${pos}`;
    }
    if (userid != '') {
      url = url + `&userid=${userid}`;
    }
    if (country != '') {
      url = url + `&country=${country}`;
    }
    if (excludeproducttype != '') {
      url = url + `&excludeproducttype=${excludeproducttype}`;
    }
    if (ordercount != '') {
      url = url + `&ordercount=${ordercount}`;
    }
    return this.http.get<ApiResponse<any>>(url);
  }
  checkOrderMessagesByStatus<T>(status): Observable<T> {
    let url = `${this.checkInData}/ordermessage/check/${status}`;
    return this.http.get<T>(url);
  }
  resendOrderMessage<T>(orderMessageId, orderId) {
    let url = `${this.checkInData}/ordermessage/sendmessage/${orderMessageId}/order/${orderId}`;
    return this.http.get<T>(url);
  }
  resendOrderMessageToEmail<T>(orderMessageId, orderId, email) {
    let url = `${this.checkInData}/ordermessage/sendmessage/${orderMessageId}/order/${orderId}?email=${email}`;
    return this.http.get<T>(url);
  }
  updateOrder(order: Order, orderId: number, archive: boolean, sendnotif: boolean, archivetxt: string) {
    let url = `${this.checkInData}/order/${orderId}?`;
    if (archive) {
      url = url + `archive=true`;
    }else{
      url = url + `archive=false`;
    }
    if (sendnotif) {
        url = url + `&sendnotif=true`;
    } else {
        url = url + `&sendnotif=false`;
    }
    if (archivetxt != '') {
      url = url + `&archivetxt=/${archivetxt}`;
    }

    return this.http.put<ApiResponse<Order>>(url, order, { observe: 'response' });
  }
  getOrderArchiveById(orderId): Observable<ApiResponse<any>> {
    const url = `${this.checkInData}/order/${orderId}/archives?group=${JSON.parse(localStorage.getItem("userDetails")).group.groupId}`;
    return this.http.get<ApiResponse<any>>(url);
  }
  postNotification(notification) {
    let url = `${this.checkInData}/notification`;
    return this.http.put<ApiResponse<any>>(url, notification, { observe: 'response' });
  }

  openClosingPeriod(id: number) {
  const url = `https://crmapi.valeriahotels.com/api/stock-closings/${id}`;
  return this.http.delete(url);
}

// Remplacez 'any' par votre modèle si vous en avez un
// Met à jour l'item de commande via son ID dans l'URL
updateOrderItem(itemId: number, payload: any): Observable<any> {
  const url = `https://crmapi.valeriahotels.com/api/order/item/${itemId}`;
  return this.http.put(url, payload); 
}

// Met à jour la réservation via l'URL globale
updateReservation(payload: any): Observable<any> {
  const url = `https://pmsvaleriaapi.fractalstay.com/api/reservations`;
  return this.http.put(url, payload);
}

// updateReservation(reservationId: number, payload: any): Observable<any> {
//   // 🚨 On ajoute dynamiquement l'ID à la fin de l'URL
//   const url = `https://pmsvaleriaapi.fractalstay.com/api/reservations/${reservationId}`;
  
//   // On envoie la requête (généralement un PUT sur ce genre d'URL, mais vous pouvez mettre post si le backend l'exige)
//   return this.http.put(url, payload); 
// }
// Mettre à jour la commande complète (Order)
updateOrder1(orderId: number, payload: any): Observable<any> {
  const url = `https://crmapi.valeriahotels.com/api/order/${orderId}`;
  return this.http.put(url, payload); 
}
}